import loadable from '@loadable/component';


export default loadable(() => import(/* webpackChunkName: "userPortfolio" */ '../layouts/UserPortfolio'));
